import Swiper, { Pagination, Navigation, Autoplay } from "swiper";

export default class ModSliderUnidades {
    constructor() {

        this.module = document.querySelector('.modulo-slider_unidades')
        this.slider = this.module.querySelector(".swiper--modulo-slider_unidades");
		this.navigationPrev = this.module.querySelector(".slider-button-prev")
        this.navigationNext = this.module.querySelector(".slider-button-next")		

        this.ready()

    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
        })
        
    }

}